<section class="d-flex w-100 justify-content-between mt-2">
    <section class="btn-toolbar">
        <div class="ms-2">
            <p>Periode: </p>
        </div>

        <app-month-picker class="ms-2"
                          id="periode"
                          name="periode"
                          #periodePicker="ngModel"
                          (monthChange)="onPeriodeChange($event, periodePicker.valid)"
                          [ngModel]="periode"
                          mask="LL-yy"
                          placeholder="mm-åå"></app-month-picker>


        <div class="ms-2">
            <p>Medarbejder: </p>
        </div>
        <div ngbDropdown class="d-inline-block">
            <button class="btn btn-primary btn-sm btn--menu ms-2" id="medarbejderselect" ngbDropdownToggle>{{getSelectedMedarbejderText(selectedMedarbejder)}}</button>
            <div ngbDropdownMenu aria-labelledby="medarbejderselect">
                <button (click)="onSelectMedarbejder(null)" class="dropdown-item">Alle</button>
                <button *ngFor="let medarbejder of medarbejdere" (click)="onSelectMedarbejder(medarbejder.cardId)" class="dropdown-item"> {{medarbejder.fornavn}} {{medarbejder.efternavn}} </button>
            </div>
        </div>

        <div class="ms-2">
            <p>LA: </p>
        </div>
        <div ngbDropdown class="d-inline-block">
            <button class="btn btn-primary btn-sm btn--menu ms-2" id="laselect" ngbDropdownToggle>{{selectedLedelseansvarligeName || 'Alle'}}</button>
            <div ngbDropdownMenu aria-labelledby="laselect">
                <button (click)="onSelectLedelseansvarlige(null, null, null)" class="dropdown-item">Alle</button>
                <button *ngFor="let ledelseansvarlig of laCards" (click)="onSelectLedelseansvarlige(ledelseansvarlig.cardId, ledelseansvarlig.fornavn, ledelseansvarlig.efternavn)" class="dropdown-item"> {{ledelseansvarlig.fornavn}} {{ledelseansvarlig.efternavn}}</button>
            </div>
        </div>

        <div class="ms-2">
            <p>KA: </p>
        </div>
        <div ngbDropdown class="d-inline-block">
            <button class="btn btn-primary btn-sm btn--menu ms-2" id="kaselect" ngbDropdownToggle>{{selectedKundeansvarligeName || 'Alle'}}</button>
            <div ngbDropdownMenu aria-labelledby="kaselect">
                <button (click)="onSelectKundeansvarlige(null, null, null)" class="dropdown-item">Alle</button>
                <button *ngFor="let kundeansvarlig of kaCards" (click)="onSelectKundeansvarlige(kundeansvarlig.cardId, kundeansvarlig.fornavn, kundeansvarlig.efternavn)" class="dropdown-item"> {{kundeansvarlig.fornavn}} {{kundeansvarlig.efternavn}}</button>
            </div>
        </div>

        <div class="ms-2">
            <p>Koncern: </p>
        </div>
        <div ngbDropdown class="d-inline-block">
            <button class="btn btn-primary btn-sm btn--menu ms-2" id="koncernselect" ngbDropdownToggle>{{selectedKoncern || 'Alle'}}</button>
            <div ngbDropdownMenu aria-labelledby="koncernselect">
                <button (click)="onSelectKoncern(null)" class="dropdown-item">Alle</button>
                <button *ngFor="let koncern of koncerns" (click)="onSelectKoncern(koncern)" class="dropdown-item"> {{koncern}}</button>
            </div>
        </div>

        <div ngbDropdown class="d-inline-block">
            <button class="btn btn-primary btn-sm btn--menu ms-2" id="timerKrFormat" ngbDropdownToggle>{{selectedHourFormat || ' - Vælg -'}}</button>
            <div ngbDropdownMenu aria-labelledby="timerKrFormat">
                <button *ngFor="let format of hourFormats" (click)="onSelectHourFormat(format.value)" class="dropdown-item">{{format.text}}</button>
            </div>
        </div>

        <div class="ms-2">
            <p>Decimaler: </p>
        </div>
        <div ngbDropdown class="d-inline-block">
            <button class="btn btn-primary btn-sm btn--menu ms-2" id="decimaler" ngbDropdownToggle>
                {{ selectedDecimal !== null && selectedDecimal !== undefined ? selectedDecimal : '- Vælg -' }}
            </button>
            <div ngbDropdownMenu aria-labelledby="decimaler">
                <button *ngFor="let decimal of decimals" (click)="onSelectDecimal(decimal)" class="dropdown-item">{{decimal}}</button>
            </div>
        </div>

        <div class="ms-2">
            <p> Deciminutter: </p>
        </div>
        <div>
            <input type="checkbox" [(ngModel)]="inDeciminutes" (change)="onSelectDeciminuts(inDeciminutes)">
        </div>

        <div class="ms-2">
            <p> Fjern afsluttede: </p>
        </div>
        <div>
            <input type="checkbox" [(ngModel)]="removeAfsluttet" (change)="onRemoveAfsluttet(removeAfsluttet)">
        </div>
    </section>
    <section class="btn-toolbar me-2">
        <div>
            <button (click)="onExportExcel()" class="btn btn--menu btn-primary btn-sm" type="submit">Eksport</button>
        </div>
    </section>
</section>
